var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"mode":"jacket"}},[_c('div',{staticClass:"MainData"},[_c('IconSet',{staticClass:"mb-4",attrs:{"icon":"success","state":""}}),_c('h1',[_vm._v(_vm._s(_vm.labels.Title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.labels.Description)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }